<div *ngIf="!isLoaded" class="spinner-border" role="status">
  <span class="visually-hidden">Loading...</span>
</div>

<!--<h4 class="fw-bold py-3 mb-2">Datasets</h4>
<hr class="container-m-nx border-light my-0" />-->

<div class="card" *ngIf="isLoaded">
<!--<div class="card-header">Overview of all Datasets</div>-->
<div  id="grid-container" class="card-body">
    <angular-slickgrid gridId="gridApprovals"
              [columnDefinitions]="columnDefinitions"
              [gridOptions]="gridOptions"
              [dataset]="dataset">
    </angular-slickgrid>
</div>
</div>
